const THEME_KEY = 'lhrc-theme';
const VALID_THEMES = ['white', 'darkBlue'];

/**
 * Get the current theme from localStorage. Defaults to 'white' if missing or invalid.
 * @returns {'white'|'darkBlue'}
 */
export function getTheme() {
  if (typeof window === 'undefined') return 'white';
  const stored = localStorage.getItem(THEME_KEY);
  return VALID_THEMES.includes(stored) ? stored : 'white';
}

/**
 * Apply theme to the document (sets data-theme on <html>) and persist to localStorage.
 * Call this when the user changes theme and on app load so the first paint uses saved theme.
 * @param {'white'|'darkBlue'} theme
 */
export function setTheme(theme) {
  const value = VALID_THEMES.includes(theme) ? theme : 'white';
  if (typeof window !== 'undefined') {
    if (value === 'white') {
      document.documentElement.removeAttribute('data-theme');
    } else {
      document.documentElement.setAttribute('data-theme', value);
    }
    localStorage.setItem(THEME_KEY, value);
    window.dispatchEvent(new CustomEvent('lhrc-theme-change', { detail: value }));
  }
}

/**
 * Read theme from localStorage and apply to document. Call once at app entry (e.g. index.js)
 * so the correct theme is applied before React renders and avoids a flash.
 */
export function applyThemeFromStorage() {
  setTheme(getTheme());
}
